import { createFileRoute } from '@tanstack/react-router';
import { getAuditLogsTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/targets/mapping/$id/audit/$idMapping')({
  beforeLoad: () => getAuditLogsTitleContextSlice(),
  staticData: {
    owner: CodeOwner.Assets,
  },
});
